import { Modal, Button, Typography, Flex } from 'antd';
import { FC, useState } from 'react';
import './CronofyConnectModal.scss';
import calendarImg from './connect-calendar.png';

interface CronofyConnectModalProps {
  open: boolean;
  onConnect: () => void;
  onClose?: () => void;
}

export const CronofyConnectModal: FC<CronofyConnectModalProps> = ({
  open,
  onConnect,
  onClose,
}) => {
  return (
    <Modal
      open={open}
      footer={null}
      closable={true}
      centered
      rootClassName="cronofy-connect-modal"
      maskClosable={false}
      onCancel={onClose}
    >
      <div className="cronofy-modal-img-wrap">
        <img
          src={calendarImg}
          alt="Connect Calendar"
          className="cronofy-modal-img"
        />
      </div>
      <Typography.Title level={3} className="cronofy-modal-title">
        Connect Your Calendar
      </Typography.Title>
      <Typography.Paragraph className="cronofy-modal-desc">
        Connect your calendar to provide real-time availability to franchisors
        and streamline scheduling
      </Typography.Paragraph>
      <Flex justify={'center'} align={'center'} className="button-flex">
        <Button
          type="primary"
          className="cronofy-modal-connect-btn"
          block
          size="large"
          onClick={onConnect}
        >
          Connect Calendar
        </Button>
        <Button
          className="cronofy-modal-skip-btn"
          block
          size="large"
          onClick={onClose}
        >
          Skip for Now
        </Button>
      </Flex>
    </Modal>
  );
};
